export interface IncentiveApiData {
    incentiveName: string;
    incentiveDescription: string;
    incentiveScopeDescription: string;
    incentiveProgramContactInfo: string;
    incentiveProgramEmail: string;
    incentiveProgramPhoneNumber: string;
    incentiveApplicationUrl: string;
    incentiveUrl: string;
    incentiveNature: string;
    potentialValue: string;
    grantorName: string;
    grantorType: string;
    startDate: string;
    expirationDate: string;
    eligibleEquipment: string[];
    eligibleProjectTypes: string;
    eligibleProjectTypeDescription: string;
    eligibleVehicleType: string;
    eligibleVehicleTypeDescription: string;
    eligibleVehicleDuties: string;
    eligibleVehicleWeightClasses: string;
    eligibleFuelTypes: string;
    eligibleOrganizations: string;
    eligibleChargingTechnology: string;
    eligibilityAssumptions: string;
    fundingCapPerProject: string;
    fundingCapPerApplicant: number;
    currentProgramStatus: string;
    currentFundingStatus: string;
    totalFunding: number;
    currentFunding: number;
    fundingSituationDescription: string;
    methodologyDescription: string;
    changeLogs: ChangeLog[];
    userFriendlyDeadline: string;
}

export interface ChangeLog {
    type: string;
    date: string;
    description: string;
    anticipatedChanges: string;
    nextScheduledReview: string;
}

interface IncentivesDataType {
    data: IncentiveApiData[];
}

export const emptyIncentiveData: IncentiveApiData = {
    incentiveName: 'Invalid Incentive',
    incentiveDescription: '',
    incentiveScopeDescription: '',
    incentiveProgramContactInfo: '',
    incentiveProgramEmail: '',
    incentiveProgramPhoneNumber: '',
    incentiveApplicationUrl: '',
    incentiveNature: '',
    potentialValue: '',
    grantorName: '',
    grantorType: '',
    startDate: '',
    expirationDate: '',
    eligibleEquipment: [],
    eligibleProjectTypes: '',
    eligibleProjectTypeDescription: '',
    eligibleVehicleType: '',
    eligibleVehicleTypeDescription: '',
    eligibleVehicleDuties: '',
    eligibleVehicleWeightClasses: '',
    eligibleFuelTypes: '',
    eligibleOrganizations: '',
    eligibleChargingTechnology: '',
    eligibilityAssumptions: '',
    fundingCapPerProject: '',
    fundingCapPerApplicant: 0,
    currentProgramStatus: '',
    currentFundingStatus: '',
    totalFunding: 0,
    currentFunding: 0,
    fundingSituationDescription: '',
    methodologyDescription: '',
    changeLogs: [
        {
            type: '',
            date: '',
            description: '',
            anticipatedChanges: '',
            nextScheduledReview: '',
        },
    ],
    userFriendlyDeadline: '',
    incentiveUrl: '',
};

export interface CsvIncentiveData {
    'Expiration Date': string;
    'Eligible Organization Type Description': string;
    'Incentive App URL': string;
    'Incentive Type': string;
    'Incentive Details URL': string;
    'Calculation Methodology Description': string;
    Name: string;
    'Eligible Technology Description': string;
    'Eligibility Assumptions': string;
    'Current Funding': number;
    'Start Date': string;
    'Eligible Technology': string;
    'Typical Amount': string;
    'Grantor Type': string;
    Status: string;
    'Eligible Project Types': string;
    'Incentive Scope': string;
    'Incentive Description': string;
    'Eligible Project Type Description': string;
    'Funding Cap Per Applicant': number;
    Grantor: string;
    'Eligible Organization Types': string;
    'Total Funding': number;
    'Incentive Program Contact Info': string;
    'Time Remaining': string;
    'Funding Cap Per Project': string;
}

export default IncentivesDataType;
